/**
 * Result page translations
 * Training recommendations result page UI text
 */

import { LANGUAGES } from '../config';

export const resultTranslations = {
  [LANGUAGES.EN]: {
    title: 'Training Recommendations',
    generateButton: 'Generate Recommendations',
    generatePrompt: 'Ready to discover your training path?',
    generateDescription: 'Generate personalized training recommendations based on your CV, job skills, and company research.',
    generatedSuccessfully: 'Training recommendations generated successfully',
    generationFailed: 'Failed to generate training recommendations',
    savedSuccessfully: 'Training recommendations saved successfully',
    saveFailed: 'Failed to save training recommendations',
    confirmLeave: 'You have unsaved recommendations. Are you sure you want to leave this page?',
    confirmBackDialogTitle: 'Return to Initial View',
    confirmBackDialogContent: 'Are you sure you want to go back to the initial view? You will need to generate the recommendations again.',
    immediateRecommendations: 'Immediate Recommendations',
    futureRecommendations: 'Future Career Growth',
    aiRecommendations: 'AI Skills Enhancement',
    addresses: 'Addresses skills',
    reason: 'Why this matters:',
    suggestedResources: 'Suggested Resources:',
    immediateDescription: 'High-priority trainings to address critical skill gaps',
    futureDescription: 'Strategic trainings for long-term career growth',
    aiDescription: 'Trainings to stay competitive in an AI-driven future',
    noRecommendations: 'No Training Recommendations',
    emptyRecommendationsDescription: 'No training recommendations have been generated yet. Complete your CV analysis, job analysis, and company research, then click "Generate Recommendations" to get personalized training suggestions.',
    regenerate: 'Regenerate',
    loadingRecommendations: 'Loading training recommendations...'
  },
  [LANGUAGES.FR]: {
    title: 'Recommandations de Formation',
    generateButton: 'Générer des Recommandations',
    generatePrompt: 'Prêt à découvrir votre parcours de formation?',
    generateDescription: 'Générez des recommandations de formation personnalisées basées sur votre CV, vos compétences professionnelles et la recherche sur l\'entreprise.',
    generatedSuccessfully: 'Recommandations de formation générées avec succès',
    generationFailed: 'Échec de la génération des recommandations de formation',
    savedSuccessfully: 'Recommandations de formation enregistrées avec succès',
    saveFailed: 'Échec de l\'enregistrement des recommandations de formation',
    confirmLeave: 'Vous avez des recommandations non enregistrées. Êtes-vous sûr de vouloir quitter cette page?',
    confirmBackDialogTitle: 'Retour à la Vue Initiale',
    confirmBackDialogContent: 'Êtes-vous sûr de vouloir revenir à la vue initiale? Vous devrez générer à nouveau les recommandations.',
    immediateRecommendations: 'Recommandations Immédiates',
    futureRecommendations: 'Développement de Carrière Futur',
    aiRecommendations: 'Amélioration des Compétences en IA',
    addresses: 'Adresse les compétences',
    reason: 'Pourquoi c\'est important:',
    suggestedResources: 'Ressources Suggérées:',
    immediateDescription: 'Formations prioritaires pour combler les lacunes critiques',
    futureDescription: 'Formations stratégiques pour la croissance de carrière à long terme',
    aiDescription: 'Formations pour rester compétitif dans un avenir axé sur l\'IA',
    noRecommendations: 'Aucune Recommandation de Formation',
    emptyRecommendationsDescription: 'Aucune recommandation de formation n\'a encore été générée. Complétez votre analyse de CV, analyse d\'emploi et recherche d\'entreprise, puis cliquez sur "Générer des Recommandations" pour obtenir des suggestions de formation personnalisées.',
    regenerate: 'Régénérer',
    loadingRecommendations: 'Chargement des recommandations de formation...'
  }
};
